import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.analyticsDashboard || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.fetchingOrdersInfoForAnalytics
);

export const selectOrdersDetails = createSelector(
  [selectDomain],
  (state) => state.ordersDetails
);

export const selectTopCommodities = createSelector(
  [selectDomain],
  (state) => state.topCommodities
);

export const selectTopPackages = createSelector(
  [selectDomain],
  (state) => state.topPackages
);

export const selectTATDetailsOnPackages = createSelector(
  [selectDomain],
  (state) => state.avgTATPackage
);

export const selectTATDetailsOnCommodities = createSelector(
  [selectDomain],
  (state) => state.avgTATCommodity
);

export const selectUsers = createSelector([selectDomain], (state) => {
  let usersArray = state.companyUsers?.users?.map((user) => ({
    label: `${user.firstName} ${user.lastName || ""}`,
    value: user._id,
  }));

  return usersArray;
});
